import { render, staticRenderFns } from "./afVerificationRecord.vue?vue&type=template&id=0fce461e&scoped=true"
import script from "./afVerificationRecord.vue?vue&type=script&lang=js"
export * from "./afVerificationRecord.vue?vue&type=script&lang=js"
import style0 from "./afVerificationRecord.vue?vue&type=style&index=0&id=0fce461e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fce461e",
  null
  
)

export default component.exports